import { cn } from '@/lib/cn'

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-shimmer rounded-sm bg-[linear-gradient(100deg,var(--color-surface-tint-strong)_38%,var(--color-surface-tint)_50%,var(--color-surface-tint-strong)_62%)] bg-[length:220%_100%] motion-reduce:animate-none',
        className,
      )}
    />
  )
}

/* Full-page loading placeholder used as Suspense/query fallback. */
export function PageSkeleton({ label = 'Loading' }: { label?: string }) {
  return (
    <div role="status" aria-label={label} className="grid gap-4 p-5">
      <Skeleton className="h-8 w-2/5" />
      <Skeleton className="h-40 rounded-card" />
      <Skeleton className="h-24 rounded-card" />
      <Skeleton className="h-24 rounded-card" />
      <span className="sr-only">{label}…</span>
    </div>
  )
}
